import { Stack } from '@mui/material';
import { useState, useCallback } from 'react';
import { HeaderMobileToggleButton } from '@/components/content/Header/parts/MobileToggleButton';
import { HeaderMobileDrawer } from '@/components/content/Header/parts/MobileDrawer';
import { SearchMobileDrawer } from '@/components/content/Header/parts/MobileDrawerSearch';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { useHeader } from '@/data/Content/Header';
import { HeaderMiniCart } from '@/components/content/Header/parts/MiniCart';
import { HeaderSearch } from '@/components/content/Header/parts/HeaderSearch';
import { ID } from '@/data/types/Basic';
import { HeaderNavBarContentRecommendation } from '@/components/content/Header/parts/HeaderNavBarContentRecommendation';

export const HeaderNavBarMobile: React.FC<{
	id: ID;
}> = ({ id }) => {
	const { contentItems } = useHeader(id);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [searchDrawerOpen, setSearchOpen] = useState(false);

	const toggleDrawer = useCallback(
		(open?: boolean) => () => {
			setDrawerOpen(open !== undefined ? open : (current) => !current);
		},
		[]
	);

	const toggleDrawerSearch = useCallback(
		(open?: boolean) => () => {
			setSearchOpen(open !== undefined ? open : (current) => !current);
		},
		[]
	);

	const logoId = `${id}-MainHeader_SuperiorSection`;

	return (
		<Stack
			width="100%"
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			spacing={2}
			px={2}
			py={1}
		>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="flex-start"
				maxWidth="129px"
				width="100%"
				spacing={2}
				sx={{ maxWidth: '129px' }}
			>
				{contentItems.map((properties) => (
					<ContentRecommendation key={logoId} id={logoId} properties={properties} />
				))}
			</Stack>
			<Stack direction="row" spacing={1} display="flex" alignItems="center">
				<HeaderSearch toggleSearch={toggleDrawerSearch} />
				<SearchMobileDrawer
					toggleSearch={toggleDrawerSearch}
					open={searchDrawerOpen}
					navBarRecommendation={
						<HeaderNavBarContentRecommendation
							onClickEntryRecommendation={toggleDrawerSearch(false)}
						/>
					}
				/>
				<HeaderMiniCart mobileBreakpoint="xs" />
				<HeaderMobileToggleButton toggleDrawer={toggleDrawer} open={drawerOpen} />
				<HeaderMobileDrawer toggleDrawer={toggleDrawer} open={drawerOpen} />
			</Stack>
		</Stack>
	);
};
